import { IPractitionerRole } from '../modules/unsw-fhir/PractitionerRole';
import { IRole } from '../contexts/practitioner';
import { IReference } from '../modules/unsw-fhir/Reference';

const getReferenceId = (reference?: IReference) => {
  if (!reference || !reference.reference) return undefined;

  const ref = reference.reference;
  const splits = ref.split('/');
  return splits[splits.length - 1];
};

export const isActive = (
  practitionerRole: IPractitionerRole | undefined,
): boolean => {
  if (!practitionerRole) return false;
  return !!practitionerRole.active;
};

export const getAllRoles = (
  practitionerRole: IPractitionerRole[] | undefined,
) => (practitionerRole ? practitionerRole.flatMap(role => getRoles(role)) : []);

export const getAllRoleDisplays = (
  practitionerRole: IPractitionerRole[] | undefined,
) =>
  practitionerRole ? practitionerRole.map(role => getRoleDisplay(role)) : [];

export const getAllRoleCodes = (
  practitionerRole: IPractitionerRole[] | undefined,
) => (practitionerRole ? practitionerRole.map(role => getRoleCodes(role)) : []);

export const getRoles = (practitionerRole: IPractitionerRole | undefined) => {
  if (
    !practitionerRole ||
    !practitionerRole.code ||
    practitionerRole.code.length <= 0
  )
    return [];
  return practitionerRole.code.flatMap(role =>
    role.coding
      ? role.coding
          .map(coding => ({
            code: coding.code,
            display: coding.display,
            organizationId: getReferenceId(practitionerRole.organization),
            active: practitionerRole.active,
          }))
          .filter((coding): coding is IRole => !!coding)
      : [],
  );
};

export const getRoleCodes = (
  practitionerRole: IPractitionerRole | undefined,
): string[] => getRoles(practitionerRole).map(role => role.code);

export const getRoleDisplay = (
  practitionerRole: IPractitionerRole | undefined,
): string[] => getRoles(practitionerRole).map(role => role.display);

export const getAllRolesByOrganizationId = (
  practitionerRole: IPractitionerRole[] | undefined,
  organizationId?: string,
) =>
  practitionerRole
    ? getAllRoles(practitionerRole).filter(
        pr => organizationId === pr.organizationId,
      )
    : [];
